'use client';

import { trpc } from '@/lib/trpc';
import type { Feature, Plan } from '@slikerr/shared';

/**
 * The signed-in business's subscription plan + resolved feature entitlements,
 * from the lightweight `business.entitlements` query (mirrors the mobile hook of
 * the same name). Long `staleTime` — plan/overrides change rarely and via
 * platform-admin only. Fails safe: while loading/erroring, `entitlements` is
 * empty and `has()` returns false, so a locked feature never flashes unlocked.
 * The server is the real gate; this only drives dashboard UX (nav lock badges).
 */
export function useEntitlements() {
  const q = trpc.business.entitlements.useQuery(undefined, {
    staleTime: 5 * 60 * 1000,
  });
  const entitlements: Feature[] = q.data?.entitlements ?? [];
  return {
    plan: q.data?.plan as Plan | undefined,
    entitlements,
    isLoading: q.isPending,
    has: (feature: Feature): boolean => entitlements.includes(feature),
  };
}
